import createHistory from 'history/createBrowserHistory' // react-router-dom library

export default createHistory()
